module.exports = __webpack_public_path__ + "static/SocialMedia-0eaea6bdfc39f824f922301b259a9552.svg";